import { v4 as uuid } from "uuid";
import { AlertType } from "../../constants";
import InputAlert from "./InputAlert";
import { isNotEmpty, isSomething } from "../../utils";

type Props = {
  id?: string;
  label?: string;
  required?: boolean;
  children?: React.ReactNode;
  hideLabel?: boolean;
  moreAlerts?: string[];
  help?: React.ReactNode;
  subLink?: React.ReactNode;
  name?: string;
  errors?: $TSFixMe;
  status?: string;
  touched?: $TSFixMe;
  objIdx?: number;
  fieldName?: string;
  info?: string;
  isHelpInlineFlex?: boolean;
  warning?: string;
  success?: string;
};

function InputGroup(props: Props) {
  const {
    id,
    name,
    help,
    info,
    label,
    objIdx,
    errors,
    status,
    touched,
    warning,
    success,
    required,
    children,
    hideLabel,
    fieldName,
    moreAlerts,
    isHelpInlineFlex,
    subLink,
  } = props;

  let type = {
    stateClass: "form-group",
    alertType: "",
    alertMessage: "",
  };

  let dirty = false;
  let error;

  // MULTI-DIMENSIONAL-FORMIK
  if (isSomething(objIdx) && isSomething(fieldName)) {
    if (
      isSomething(errors) &&
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      isSomething(errors[name]) &&
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      isSomething(errors[name][objIdx]) &&
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      isSomething(errors[name][objIdx][fieldName])
    ) {
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      error = errors[name][objIdx][fieldName];
    }
    if (
      touched &&
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      touched[name] &&
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      touched[name][objIdx] &&
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      touched[name][objIdx][fieldName]
    ) {
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      dirty = touched[name][objIdx][fieldName];
    }
    dirty = dirty || status === "submitted";
    // FORMIK
  } else {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    error = name.split(".").reduce((p, c) => p?.[c], errors);
    dirty =
      status === "submitted" ||
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      name.split(".").reduce((p, c) => p?.[c], touched);
  }

  if (dirty && isNotEmpty(error)) {
    type = {
      stateClass: "form-group has-error",
      alertType: AlertType.ERROR,
      alertMessage: error,
    };
  } else if (isNotEmpty(warning)) {
    type = {
      stateClass: "form-group has-warning",
      alertType: AlertType.WARNING,
      // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      alertMessage: warning,
    };
  } else if (isNotEmpty(info)) {
    type = {
      stateClass: "form-group has-info",
      alertType: AlertType.INFO,
      // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      alertMessage: info,
    };
  } else if (isNotEmpty(success)) {
    type = {
      stateClass: "form-group has-success",
      alertType: AlertType.SUCCESS,
      // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      alertMessage: success,
    };
  } else {
    type = {
      stateClass: "form-group",
      alertMessage: "",
      alertType: "",
    };
  }

  const labelText = required ? `${label}*` : label;

  const additionalInfos =
    moreAlerts && type.alertMessage !== moreAlerts[0] ? (
      <div>
        {moreAlerts.length > 0 ? (
          <div>
            {moreAlerts.map((message) => (
              <InputAlert
                message={message}
                type={AlertType.INFO}
                key={uuid()}
              />
            ))}
          </div>
        ) : null}
      </div>
    ) : null;

  const renderedLabel = hideLabel ? null : (
    <label
      className={isHelpInlineFlex ? "input-group-inline-flex-help" : ""}
      htmlFor={id}
    >
      {labelText}
      {help}
    </label>
  );

  return (
    <div id={id} className={type.stateClass} data-testid={`input-group-${id}`}>
      {renderedLabel}
      {children}
      <InputAlert message={type.alertMessage} type={type.alertType} />
      {additionalInfos}
      {subLink}
    </div>
  );
}

export default InputGroup;
